export default {
  completeShopFirst: {
    description: 'Complete your shop settings before changing your billing method.',
    button: 'Complete Shop Settings'
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/translations/billing_method/en.js